import React from "react";
import { useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { parentController } from "../../_api/controllers/parent.controller.ts";
import {
  promotionController,
  schoolYearController,
} from "../../_api/controllers/scolarite.controller.ts";
import { studentControler } from "../../_api/controllers/student.controller.ts";
import { capitalizeFirstLetter } from "../../_services/utils";

const Parent: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();

  const queryClient = useQueryClient();

  //fetch all users
  const { data: parentsData } = useQuery({
    queryKey: ["parents"],
    queryFn: parentController.getAll,
  });

  //fetch eleves
  const { data: studentData } = useQuery({
    queryKey: ["students"],
    queryFn: studentControler.getAll,
  });

  //fetch promotion
  const { data: promotionsData } = useQuery({
    queryKey: ["promotions"],
    queryFn: promotionController.getAll,
  });
  //fetch anne scolaire
  const { data: schoolYearData } = useQuery({
    queryKey: ["schoolYears"],
    queryFn: schoolYearController.getAll,
  });

  const studentDataArr = studentData?.data || [];
  const promotionsDataArr = promotionsData?.data || [];
  const parentsDataArr = parentsData?.data || [];
  const schoolYearDataArr = schoolYearData?.data || [];

  const activeShoolYear = schoolYearDataArr.filter((item) => item.status);

  const updateParentsArr = parentsDataArr.map((parent) => {
    let students = [];
    let activeStudents = [];

    for (let student of studentDataArr) {
      if (parent.parent_id === student.parent_id) {
        students.push(student);
      }
    }

    for (let promo of promotionsDataArr) {
      for (let item of students) {
        if (
          promo.eleve_id === item.eleve_id &&
          promo.annee_scolaire_id === activeShoolYear[0].id
        ) {
          activeStudents.push(item);
        }
      }
    }
    return {
      ...parent,
      students: activeStudents,
    };
  });

  console.log(updateParentsArr);

  return (
    <div className="space-y-6">
      <div
        className={`rounded-lg overflow-hidden border ${
          isDarkMode ? "border-gray-700" : "border-gray-300"
        }`}
      >
        <div className={`p-5 ${isDarkMode ? "bg-[#0D1117]" : "bg-white"}`}>
          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div
              className={`p-4 rounded-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Total Parents
                  </p>
                  <h3 className="text-2xl font-bold">320</h3>
                </div>
                <div
                  className={`p-3 rounded-full ${
                    isDarkMode ? "bg-blue-900" : "bg-blue-100"
                  }`}
                >
                  <i
                    className={`fas fa-users ${
                      isDarkMode ? "text-blue-400" : "text-blue-600"
                    }`}
                  ></i>
                </div>
              </div>
            </div>
            <div
              className={`p-4 rounded-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Parents actifs
                  </p>
                  <h3 className="text-2xl font-bold">285</h3>
                </div>
                <div
                  className={`p-3 rounded-full ${
                    isDarkMode ? "bg-green-900" : "bg-green-100"
                  }`}
                >
                  <i
                    className={`fas fa-user-check ${
                      isDarkMode ? "text-green-400" : "text-green-600"
                    }`}
                  ></i>
                </div>
              </div>
            </div>
            <div
              className={`p-4 rounded-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Archivés
                  </p>
                  <h3 className="text-2xl font-bold">35</h3>
                </div>
                <div
                  className={`p-3 rounded-full ${
                    isDarkMode ? "bg-gray-800" : "bg-gray-200"
                  }`}
                >
                  <i
                    className={`fas fa-archive ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  ></i>
                </div>
              </div>
            </div>
          </div>
          {/* Search and Filters */}
          <div className="flex flex-wrap gap-4 mb-6">
            <div className="flex-grow relative">
              <div
                className={`absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500`}
              >
                <i className="fas fa-search"></i>
              </div>
              <input
                type="text"
                placeholder="Rechercher un parent..."
                className={`w-full pl-10 pr-4 py-2 rounded-md text-sm ${
                  isDarkMode
                    ? "bg-[#161B22] border-gray-700"
                    : "bg-white border-gray-300"
                } border focus:outline-none focus:ring-2 focus:ring-blue-500`}
              />
            </div>
            <div className="relative">
              <button
                className={`flex items-center px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-[#161B22] hover:bg-gray-700"
                    : "bg-white hover:bg-gray-100"
                } border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                <span>Tous les statuts</span>
                <i className="fas fa-chevron-down ml-2"></i>
              </button>
            </div>
            <button
              className={`px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-green-600 hover:bg-green-700"
                  : "bg-green-500 hover:bg-green-600"
              } text-white !rounded-button whitespace-nowrap`}
            >
              <i className="fas fa-plus mr-2"></i>Ajouter un parent
            </button>
          </div>
          {/* Parents Table */}
          <div
            className={`rounded-lg overflow-hidden border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            }`}
          >
            <table className="min-w-full divide-y divide-gray-700">
              <thead
                className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}
              >
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Nom & Prénom
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Email
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Téléphone
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Enfants actifs
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Statut
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody
                className={`${
                  isDarkMode ? "bg-[#0D1117]" : "bg-white"
                } divide-y ${
                  isDarkMode ? "divide-gray-700" : "divide-gray-200"
                }`}
              >
                {updateParentsArr.map((item, index) => (
                  <tr key={item.id}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-10 w-10">
                          <div
                            className={`h-10 w-10 rounded-full flex items-center justify-center ${
                              isDarkMode ? "bg-gray-700" : "bg-gray-200"
                            }`}
                          >
                            <i className="fas fa-user"></i>
                          </div>
                        </div>
                        <div className="ml-4">
                          <span
                            className={`px-0 inline-flex text-xs leading-5 font-semibold rounded-full ${
                              isDarkMode ? "text-gray-200" : "text-gray-700"
                            }`}
                          >
                            {capitalizeFirstLetter(item.nom)}{" "}
                            {capitalizeFirstLetter(item.postnom)}{" "}
                            {capitalizeFirstLetter(item.prenom)}
                          </span>{" "}
                          <div
                            className={`text-sm ${
                              isDarkMode ? "text-gray-400" : "text-gray-500"
                            }`}
                          >
                            ID: PAR-00{index + 1}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4  whitespace-nowrap">
                      {item.email ? item.email : "---------------"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {item.telephone ? item.telephone : "-"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          !!item.students.length
                            ? "bg-green-100 text-green-800"
                            : "bg-gray-100 text-gray-800"
                        } `}
                      >
                        {!!item.students.length
                          ? `${item.students.length} enfants`
                          : "Aucun"}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          item.status
                            ? "bg-blue-100 text-blue-800"
                            : "bg-red-100 text-red-800"
                        } `}
                      >
                        {item.status ? "Actif" : "Inactif"}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <div className="flex justify-center space-x-3">
                        {/* <button className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap">
                          <i className="fas fa-eye"></i>
                        </button> */}
                        <button className="text-green-500 hover:text-green-700 cursor-pointer !rounded-button whitespace-nowrap">
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          className={`${
                            item.status
                              ? "text-green-500 hover:text-green-700"
                              : "text-gray-500 hover:text-green-700"
                          } cursor-pointer !rounded-button whitespace-nowrap`}
                        >
                          <i className="fa-solid fa-circle-check"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* Pagination */}
          <div className="mt-4 flex items-center justify-between">
            <div
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-500"
              }`}
            >
              Affichage de {updateParentsArr.length} parents
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Parent;
